import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-center mt-4" }
const _hoisted_2 = { class: "d-block" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "table table-bordered border-0 mb-4 table-edit" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FHA"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CONVENTIONAL"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "VA")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MINIMMUM DOWN PAYMENT %"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MINIMMUM DOWN PAYMENT %"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MINIMMUM DOWN PAYMENT %")
  ])
], -1)
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)

import { toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MinimumDownPayment',
  props: {
    subTitle: String,
    title: String,
    tableData: [],
    addFunctionTwo: Function
},
  setup(__props) {

const props = __props;



const { title, subTitle, tableData, addFunctionTwo } = toRefs(props);

const addElement = () => {
    addFunctionTwo.value()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(subTitle)), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(title)), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", null, [
      _createElementVNode("table", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableData), (data, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "data",
              key: index
            }, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((data.fha_score) = $event)
                }, null, 8, _hoisted_7), [
                  [_vModelText, data.fha_score]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((data.fha_percent) = $event)
                }, null, 8, _hoisted_8), [
                  [_vModelText, data.fha_percent]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((data.conventional_score) = $event)
                }, null, 8, _hoisted_9), [
                  [_vModelText, data.conventional_score]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((data.conventional_percent) = $event)
                }, null, 8, _hoisted_10), [
                  [_vModelText, data.conventional_percent]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((data.va_score) = $event)
                }, null, 8, _hoisted_11), [
                  [_vModelText, data.va_score]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((data.va_percent) = $event)
                }, null, 8, _hoisted_12), [
                  [_vModelText, data.va_percent]
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary px-5",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addElement()))
      }, [
        _createTextVNode("Add "),
        _hoisted_13
      ])
    ])
  ]))
}
}

})